module.exports = __webpack_public_path__ + "img/goods5_2.07baec55.jpg";